import { css } from "styled-components";
export const BorderSolidSlimBlack = css `
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  border-color: darkgrey;
`;
